import { faCircleCheck, faPlayCircle } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { selectLastPlayedLesson } from '../../redux/personaliseLessons/nameSlice'
import { Mixpanel } from '../../config/Mixpanel'
import constants from '../PersonaliseLessons/utilities/constants'
import { toast } from 'react-toastify'
import { faCheck, faExclamation } from '@fortawesome/free-solid-svg-icons'
import { Line } from 'rc-progress'


const CourseSyllabus = ({ courseModule, courseName }) => {

    const [ showCourse, setShowCourse ] = useState([true, ...Array(courseModule?.course_data?.length > 0 ? courseModule?.course_data?.length - 1 : 0).fill(false)])
    const setLastWatchedLesson = useSelector(selectLastPlayedLesson)
    const navigate = useNavigate()

    const handleClick = (index, lessonName) => {
        Mixpanel.track(constants.Mixpanel.COURSE_LIST_PAGE_CLICKED_ON_LESSON)
        navigate(`/personalise/${encodeURIComponent(courseName)}/${courseModule?.course_data?.[index]?.module_slug}/${lessonName}`)
    }

    const handleShowCourse = (index) => {
        setShowCourse((prevLessons) => {
            const updatedLessons = [...prevLessons]
            updatedLessons[index] = !prevLessons[index]
            return updatedLessons
        })
    }

    function formatTime(seconds) {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
      
        let formattedTime = '';
      
        if (hours > 0) {
          formattedTime += hours + ' hr ';
        }
      
        if (minutes > 0) {
          formattedTime += minutes + ' min';
        }
      
        return formattedTime.trim();
    }
    
    return (
        <div>
            <h2 className='text-2xl font-semibold'>Course Syllabus</h2>
            {courseModule?.course_data?.map((item, index) => {
                const noOfQuizIncomplete = item?.module_content?.filter((lesson) => lesson?.lesson_status !== "completed")?.length
                const percentage = 100 * (1- (noOfQuizIncomplete/item?.module_content?.length))
                return (<div key={index} className='bg-[#2D4F71] p-3 rounded-xl mt-3 cursor-pointer' onClick={() => {
                    if (!item?.is_locked){
                        handleShowCourse(index)
                    } else if (index > 0 && courseModule?.course_data?.[index - 1]?.module_progress === 100){
                        toast.warning('Loading your Module. Please wait!')
                    } else {
                        toast.warning('Complete previous module to unlock this module.')
                    }
                }}>
                    <div className='flex items-center gap-3'>
                        {item?.module_progress === 100 ? <FontAwesomeIcon icon={faCircleCheck} className='text-[#00C838] text-2xl'/> : item?.module_progress > 0 ? <div className='w-8 h-8 border-2 border-[#F59E0B] rounded-full flex items-center justify-center'><FontAwesomeIcon icon={faExclamation} className='text-[#F59E0B] text-xl'/></div> : <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Pending_1.png?updatedAt=1689672495417" alt="" width={24} height={24}/>}
                        <div className='flex-1 flex flex-col'>
                            <div className='flex items-center'>
                                <div className='flex-1'>
                                    <h3 className='font-semibold leading-5'>{item?.module_name}</h3>
                                    <div className='text-[#92B3BE] text-sm flex items-center'>
                                        <p className='mr-2'>{item?.module_content?.length} lessons</p>
                                        <div className='w-1 h-1 rounded-full bg-[#92B3BE] mr-2'></div>
                                        <p>{item?.module_duration ? formatTime(item?.module_duration) : formatTime(item?.module_content?.length * 15*60)}</p>
                                    </div>
                                </div>
                                {item?.is_locked && <div className='w-6 h-6'>
                                    <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Lock_6.svg?updatedAt=1689232670218" alt="" className='w-full h-full'/>
                                </div>}
                                <div className='ml-2 flex items-center'>
                                    {!showCourse[index] ? <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Chevron_4.png?updatedAt=1689672710809" width={20} height={20} alt="" /> : <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Chevron_4__1_.png?updatedAt=1689672788505" width={20} height={20} alt="" />}
                                </div>
                            </div>
                            {(!item?.is_locked && item?.module_progress !== 100) && <div className='flex w-full items-center gap-2'>
                                <p className='text-nowrap text-[#92B3BE] text-sm'>{noOfQuizIncomplete} Quiz{noOfQuizIncomplete > 1 ? 'zes' : ''} Left!</p>
                                <div className='w-full max-md:flex-1 md:w-1/3'>
                                    <Line percent={percentage} strokeColor={'#F59E0B'} trailColor='#FFE2B0' strokeWidth={2.5} trailWidth={2.5} />
                                </div>
                            </div>}
                        </div>
                    </div>
                    
                    {showCourse[index] ? <div className='mt-3'>
                        {item?.module_content?.map((lesson, indexNo) => (
                            <div key={indexNo} className='flex mb-4 cursor-pointer' onClick={() => handleClick(index, lesson?.lesson_slug)}>
                                <div className='w-20 h-14 relative'>
                                    <img src={lesson?.thumbnail_url} alt="" className={`w-full h-auto rounded-[11px] ${lesson?.lesson_status === 'completed' && 'blur-[2px]'} ${(lesson?.lesson_status !== 'completed' && lesson?.lesson_status !== '') && 'border-2 border-[#F59E0B]'} ${lesson?.lesson_status === '' && 'opacity-50'}`}/>
                                    {lesson?.lesson_status === "completed" ? <div className='w-5 h-5 rounded-full border-2 flex items-center justify-center border-[#54A3F5] absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2'><FontAwesomeIcon icon={faCheck} className='text-[#54A3F5] font-bold text-sm' style={{ strokeWidth: 2 }}/></div> : setLastWatchedLesson === lesson?.lesson_id ? <FontAwesomeIcon icon={faPlayCircle} className='text-lg text-[#00C838] absolute inset-0 mx-auto my-auto'/> : lesson?.lesson_status === "" ? <FontAwesomeIcon icon={faPlayCircle} className='text-lg absolute inset-0 mx-auto my-auto'/> : lesson?.lesson_status === "inprogress" || lesson?.lesson_status === "quizpending" ? <div className='w-5 h-5 rounded-full border-2 flex items-center justify-center border-[#F59E0B] absolute inset-0 mx-auto my-auto'><FontAwesomeIcon icon={faExclamation} className='text-[#F59E0B] font-bold text-sm' style={{ strokeWidth: 2 }}/></div> : null}
                                </div>
                                <div className={`w-[75%] ml-3 ${lesson?.intro_text?.length > 0 ? '' : 'flex flex-col justify-center'}`}>
                                    <h4 className='font-semibold leading-5 line-clamp-2'>{lesson?.lesson_name}</h4>
                                    {lesson?.intro_text?.length > 0 ? (lesson?.intro_text?.length > 100 ? <p className='text-xs text-white/50'>{lesson?.intro_text?.substring(0, 97)}...</p> : <p className='text-xs text-white/50'>{lesson?.intro_text}</p>) : null}
                                </div>
                            </div>
                        ))}
                    </div> : null}
                </div>
            )})}
        </div>
  )
}

export default CourseSyllabus
